import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store/index.js'
// auth
import Login from "@/views/auth/Login.vue"

// Dashboard
import Dashboard from "@/views/Dashboard.vue";

// configuration
import Divisions from "@/views/configuration/Divisions.vue"
import SubDivisions from "@/views/configuration/SubDivision.vue"
import Circles from "@/views/configuration/Circles.vue"
import PoliceStation from "@/views/configuration/PoliceStation.vue"
import CaseStages from "@/views/configuration/CaseStages.vue"
import PropertyTypes from "@/views/configuration/Propertytypes.vue"
import PropertyDisposalStages from "@/views/configuration/PropertyDisposalStages.vue"


// Muddemaal
import Muddemaal from "@/views/muddemaal/Muddemaal.vue";
import MuddemaalCreate from "@/views/muddemaal/MuddemaalCreate.vue";
import MuddemaalEdit from "@/views/muddemaal/MuddemalEdit.vue";
import MuddemalView from "@/views/muddemaal/MuddemalView.vue";

// users
import UserCreate from '@/views/users/UserCreate.vue';
import UsersList from '@/views/users/UsersList.vue';
import ProfileUpdate from '@/views/users/ProfileUpdate.vue';
import UserLogs from '@/views/users/Logs.vue';
import UserPoliceStations from '@/views/users/Userpolicestation.vue';
import DownloadedQRCodes from '@/views/users/DownloadedQRCodes.vue';

//Reports
import AuditReportYearWise from '@/views/reports/AuditReportYearWise.vue';
import AuditReport from '@/views/reports/AuditReport.vue';
import PropertyDetailReport from '@/views/reports/PropertyDetails.vue';
import CasesStatusReport from '@/views/reports/CaseStatusYearWise.vue';
import Analytics from '@/views/reports/Analytics.vue';

const routes = [
	//Authentication
	{
		path: '/',
		name: 'Login',
		component: Login
	},
	// {
	//   path: '/login',
	//   name: 'Login',
	//   component: Login
	// },

	//Dashboard
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard
	},

	// Configuration
	{
		path: '/divisions',
		name: 'Divisions',
		component: Divisions,
		meta: { requiresAdmin: true }
	},
	{
		path: '/sub_divisions',
		name: 'SubDivisions',
		component: SubDivisions,
		meta: { requiresAdmin: true }
	},
	{
		path: '/circles',
		name: 'Circles',
		component: Circles,
		meta: { requiresAdmin: true }
	},
	{
		path: '/police_stations',
		name: 'PoliceStation',
		component: PoliceStation,
		meta: { requiresAdmin: true }
	},
	{
		path: '/case_stages',
		name: 'CaseStages',
		component: CaseStages,
		meta: { requiresAdmin: true }
	},
	{
		path: '/property_types',
		name: 'PropertyTypes',
		component: PropertyTypes,
		meta: { requiresAdmin: true }
	},
	{
		path: '/property_disposal_stages',
		name: 'PropertyDisposalStages',
		component: PropertyDisposalStages,
		meta: { requiresAdmin: true }
	},

	// Muddemaal
	{
		path: '/muddemal',
		name: 'Muddemaal',
		component: Muddemaal
	},
	{
		path: '/muddemal_create',
		name: 'MuddemaalCreate',
		component: MuddemaalCreate
	},
	{
		path: '/muddemal/:muddemal_id/edit',
		name: 'MuddemaalEdit',
		component: MuddemaalEdit,
	},
	{
		path: '/muddemal/:muddemal_id/view',
		name: 'MuddemalView',
		component: MuddemalView,
	},


	// User Management
	{
		path: '/user_create',
		name: 'UserCreate',
		component: UserCreate,
		meta: { requiresAdmin: true }
	},

	{
		path: '/user_update/:user_id',
		name: 'UserUpdate',
		component: UserCreate,
		meta: { requiresAdmin: true }
	},

	{
		path: '/users',
		name: 'UsersList',
		component: UsersList,
		meta: { requiresAdmin: true }
	},
	{
		path: '/profile_update',
		name: 'ProfileUpdate',
		component: ProfileUpdate
	},
	{
		path: '/logs',
		name: 'UsersLogs',
		component: UserLogs
	},
	{
		path: '/downloaded_qr_codes',
		name: 'DownloadedQRCodes',
		component: DownloadedQRCodes
	},
	{
		path: '/Userpolicestation/:user_id',
		name: 'Userpolicestations',
		component: UserPoliceStations,
		meta: { requiresAdmin: true }
	},
	{
		path: '/audit_report',
		name: 'AuditReport',
		component: AuditReport
	},
	{
		path: '/audit_report_year_wise',
		name: 'AuditReportYearWise',
		component: AuditReportYearWise
	},
	{
		path: '/property_details_report',
		name: 'PropertyDetailReport',
		component: PropertyDetailReport
	},
	{
		path: '/analytics',
		name: 'Analytics',
		component: Analytics
	},
	{
		path: '/cases_status_report',
		name: 'CasesStatusReport',
		component: CasesStatusReport
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

router.beforeEach(async (to, from, next) => {
	// If logout redirect is in progress, always go to landing/login page.
	// if (store.getters.isLoggingOut) {
	// 	next('/');
	// 	return;
	// }

	if (store.getters.isLoggingOut) {
		if (to.path !== '/') {
		  next('/');
		} else {
		  next();
		}
		return;
	  }

	// Check if the route requires admin access
	if (to.matched.some(record => record.meta.requiresAdmin)) {
		// Validate user is authenticated
		if (!store.state.user || !store.getters.token) {
			store.dispatch("error", "You must be logged in to access this page");
			next('/'); // Redirect to login
			return;
		}

		// Validate admin status with server before allowing navigation
		// This prevents UI exposure even if client-side flag is manipulated
		try {
			const isAdmin = await store.dispatch('validateAdminAccess');
			
			if (!isAdmin) {
				store.dispatch("error", "You don't have permission to access this page");
				next(from.path || '/muddemal'); // Redirect to muddemal page or previous page
				return;
			}
			
			// User is validated as admin by server - allow navigation
			// Note: Server will still validate on every API request for defense in depth
			next();
		} catch (error) {
			if (store.getters.isLoggingOut) {
				next('/');
				return;
			}
			// On error, deny access (fail secure)
			store.dispatch("error", "Unable to verify admin access. Please try again.");
			next(from.path || '/muddemal');
		}
	} else {
		next(); // Allow access to non-admin routes
	}
});

export default router
